import React,{useState, useEffect}  from 'react';
import Table from 'react-bootstrap/Table'
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Ckeyword(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# Keywords tutorial For Beginners</title>
 <meta name="description" content="C# Keywords tutorial for beginners.In C# there are 77 keywords CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# Keywords,c# Keywords for,c sharp Keywords" />
 <link rel="canonical" href="https://www.codeexampler.com/charp-keyword" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">Csharp(C#) keyword</h1>
    <div className="first">
        <a href="/csharp-comments">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-operator">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
<p className="mt-4 para">1, In C# there are 77 keywords <br/>
2, C# keywords cannot be used as identifiers<br/>
3, They cannot be used as names for a variable, class, or method.<br/>
4, Csharp Programming keywords are Known as Reserved Words.

</p>
<h2 className="mt-4 mh2">C# keyword programming table</h2>
    <Table responsive striped bordered hover variant="dark m-3">
 
 <tbody>
   <tr>
     
     <td>abstract</td>
     <td>as</td>
     <td>base</td>
     <td>bool</td>
     <td>char</td>
     <td>class</td>
     <td>checked</td>
     <td>const</td>
   </tr>
   <tr>
    
     <td>Keywords</td>
     <td>case</td>
     <td>byte</td>
     <td>catch</td>
     <td>continue</td>
     <td>default</td>
     <td>decimal</td>
     <td>delegate</td>
   </tr>
   <tr>
   
     <td>do</td>
     <td>else</td>
     <td>double	</td>
     <td>event</td>
     <td>enum</td>
     <td>explicit</td>
     <td>extern</td>
     <td>false</td>
    
   </tr>

   <tr>
   
     <td>foreach</td>
     <td>if</td>
     <td>goto</td>
     <td>implicit</td>
     <td>in</td>
     <td>int</td>
     <td>interface</td>
     <td>internal</td>
   </tr>

   <tr>
     
     <td>is</td>
     <td>lock</td>
     <td>long</td>
     <td>namespace</td>
     <td>new</td>
     <td>null</td>
     <td>object</td>
     <td>operator</td>
   </tr>

   <tr>
     
     <td>out</td>
     <td>params</td>
     <td>override</td>
     <td>private</td>
     <td>Protected</td>
     <td>Public</td>
     <td>readonly</td>
     <td>ref</td>
   </tr>

   <tr>
     
     <td>return</td>
     <td>sealed</td>
     <td>sbyte</td>
     <td>short</td>
     <td>sizeof</td>
     <td>static</td>
     <td>stackalloc</td>
     <td>string</td>
   </tr>

   <tr>
     
     <td>struct</td>
     <td>this</td>
     <td>switch</td>
     <td>throw</td>
     <td>true</td>
     <td>try</td>
     <td>typeof</td>
     <td>uint</td>
   </tr>

   


   <tr>
     
     <td>ulong</td>
     <td>unsafe</td>
     <td>unchecked</td>
     <td>ushort</td>
     <td>using</td>
     <td>void</td>
     <td>virtual</td>
     <td>volatile</td>

   </tr>


   <tr>
     <td>while</td>
   </tr>

 </tbody>
</Table>
  <h1 className="mt-5">  </h1>
      
  <div className="back">
        <a href="/csharp-comments">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-operator">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Ckeyword;